import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextOverviewReducer from "containers/Next/Overview/OverviewReducer";
import * as globalReducer from "containers/App/reducer";

import equal from "fast-deep-equal";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import HexGrid from "components/Next/HexGrid";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

class HexGridContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      activeTab,
      hoverNode,
      selectedHex,
      actionHexMap,
      hexMap,
      isHoverHex,
      isHover,
      isMini,
      mType,
      isAnimateReturn,
      dragHex
    } = this.props;

    return true;

    if (isHoverHex && nextProps?.isHover !== true) {
      return false;
    }

    if (!equal(hexMap, nextProps.hexMap)) {
      return true;
    }

    if (!equal(actionHexMap, nextProps.actionHexMap)) {
      return true;
    }

    if (isAnimateReturn !== nextProps.isAnimateReturn) {
      return true;
    }

    if (dragHex !== nextProps.dragHex) {
      return true;
    }

    if (
      (hoverNode === undefined && nextProps.hoverNode !== undefined) ||
      (hoverNode !== undefined && nextProps.hoverNode === undefined) ||
      hoverNode?.chart?.narrative?.title !== nextProps?.hoverNode?.chart?.narrative?.title
    ) {
      return false;
    }

    if (activeTab !== nextProps.activeTab) {
      return true;
    }

    return false;
  }

  componentDidUpdate(prevProps) {
    const { hexSize, selectedHex, activeTab } = this.props;

    if (hexSize !== prevProps.hexSize && false) {
      return setTimeout(() => nextReducer.centerHex(selectedHex), 500);
    }
  }

  render() {
    return <HexGrid {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {};
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  const activeTab = nextReducer.getActiveTab(state, id);

  let hexMap = ownProps?.hexMap
    ? ownProps?.hexMap
    : ownProps?.mType === "TRANSFORM"
      ? nextTransformReducer.getAllHex(state, id)
      : ownProps?.mType === "MODELS"
        ? nextModelsReducer.getAllHex(state, id)
        : ownProps?.mType === "EXPLORE"
          ? nextReducer.getHexMap(state, id)
          : ownProps?.mType === "OVERVIEW"
            ? nextOverviewReducer.getHexMap(state, id)
            : activeTab === "TRANSFORM"
              ? nextTransformReducer.getHexMap(state, id)
              : activeTab === "MODELS"
                ? nextModelsReducer.getAllHex(state, id)
                : activeTab === "OVERVIEW"
                  ? nextOverviewReducer.getHexMap(state, id)
                  : activeTab === "EXPLORE"
                    ? nextReducer.getHexMap(state, id)
                    : ownProps?.isTile
                      ? nextReducer.getHexMap(state, id)
                      : nextReducer.getHexMap(state, id);

  if (ownProps?.nextId !== undefined && ownProps?.explorationId !== undefined) {
    hexMap = reportReducer.getExplorationHexMap(state, ownProps?.id, ownProps?.explorationId);
  }

  return {
    id: id,
    activeTab: activeTab,

    hexSize: ownProps.hexSize !== undefined ? ownProps.hexSize : nextReducer.getHexSize(state, id),
    innerHexSize: ownProps.innerHexSize !== undefined ? ownProps.innerHexSize : nextReducer.getInnerHexSize(state, id),
    hexagonRadius: nextReducer.getHexagonRadius(state, id),

    selectedHex: nextReducer.getSelectedHex(state, id),
    selectionDirection: nextReducer.getSelectionDirection(state, id),

    isAnimateReturn: nextReducer.getIsAnimateReturn(state, id),
    pinnedHexList: nextReducer.getPinnedHexList(state, id),

    dragHex: nextReducer.getDragHex(state, id),

    hexMap: hexMap,
    actionHexMap:
      ownProps.mType !== undefined && ownProps.mType !== "EXPLORE"
        ? {}
        : activeTab === "EXPLORE" || ownProps.mType === "EXPLORE"
          ? nextReducer.getActionHexMap(state, id)
          : {}
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(HexGridContainer);
